// extracted by mini-css-extract-plugin
module.exports = {"CardContainer":"CardContainer_W3oXs"};